//Imports
import React, { useCallback, useEffect } from "react";

//Controls
import { Button, Modal } from "@gpstrackit/gtc-react-controls";

//Components
import {
    NotificationManager,
    NotificationContainer,
} from "Components/Notifications";

//Hooks
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";

//Actions
import { assetDeleteAsset, reset } from "./redux/slice";

const DeleteAsset = ({ refresh }) => {

    //Redux
    const dispatch = useDispatch();
    const { open, loading, result, error, asset, assetList } = useSelector((state) => state.manageAssetDeleteRedux);

    //Language
    const { messages } = useIntl();

    //Handlers and utils
    const handleClose = useCallback(() => dispatch(reset()), []);

    const handleDeleteSubmit = useCallback(() => {
        if (asset) {
            dispatch(assetDeleteAsset({ ids: [asset?.id] }));
        }
        if (assetList?.length) {
            let ids = assetList.map((item) => item?.id)
            dispatch(assetDeleteAsset({ ids: ids }));
        }
    }, [asset, assetList]);

    //Effects
    useEffect(() => {
        if (error) {
            let errorMessage = error.error === "CompanyReadonly" ? error.error : messages["errorMessage"];
            const errorLower = error?.error?.toLowerCase();
            if (errorLower.includes('are in use')) {
                errorMessage = messages['manage_deleteAssets_are_in_use']
            }
            NotificationManager.error(
                errorMessage,
                messages["error"],
                3000,
                null,
                null,
                "error"
            );
            dispatch(reset({ error: null }));
        }
    }, [error]);

    useEffect(() => {
        if (!result) return;
        if (result?.delete) {
            const messageSuccess = asset
                ? messages['manage_deleteAsset_successMessageUpdate']
                : messages['manage_deleteAssets_successMessageUpdate'];

            NotificationManager.success(
                messageSuccess,
                messages["success"],
                3000,
                null,
                null,
                "success"
            );
            refresh();
            dispatch(reset());
        } else {
            NotificationManager.error(
                messages["errorMessage"],
                messages["error"],
                3000,
                null,
                null,
                "error"
            );
            dispatch(reset({ result: null }));
        }
    }, [result]);

    return (
        <Modal
            title={
                asset
                    ? messages['manage_deleteAsset_title']
                    : messages['manage_deleteAssets_title']
            }
            size="small"
            open={open}
            handleClose={handleClose}
            loading={loading}
            footer={
                <div>
                    <Button
                        variant="secondary"
                        style={{ marginRight: "5px" }}
                        onClick={() => handleClose()}
                        isDisabled={loading}
                    >
                        {messages["cancel"]}
                    </Button>
                    <Button
                        variant="warning"
                        onClick={() => handleDeleteSubmit()}
                        isDisabled={loading}
                    >
                        {messages["delete"]}
                    </Button>
                </div>
            }
        >
            <div style={{ padding: "10px 25px" }}>
                <p>{asset ? messages['manage_deleteAsset_description'] : messages['manage_deleteAssets_description']}</p>
                <ul>
                    {asset ? (
                        <li style={{ wordBreak: "break-word", overflowWrap: "break-word" }}>
                            {asset?.label}
                        </li>
                    ) : (
                        assetList?.map((item, index) => (
                            <li key={index} style={{ wordBreak: "break-word", overflowWrap: "break-word" }}>
                                {item.label}
                            </li>
                        ))
                    )}
                </ul>
            </div>
            <NotificationContainer />
        </Modal>
    );
};

export default DeleteAsset;